/* eslint-disable */

import React from 'react';

const TNLComFooter = () => {
  const year = new Date().getFullYear();
  
  return (
    <footer className="GlobalFooter">
      <div className="Container GlobalFooter-container">
        <div className="GlobalFooter-section GlobalFooter-section--tertiary">
          <div className="GlobalFooter-companyInfo">
            <p>
              © Times Media Limited {year}.&nbsp;<br />
              Registered in England No. 894646.&nbsp;Registered office: 1 London Bridge Street, SE1 9GF.
            </p>
          </div>
          <ul className="GlobalFooter-list GlobalFooter-list--small">
            <li>
              <a href="https://www.newsprivacy.co.uk/single/">Privacy &amp; cookie policy</a>
            </li>
            <li>
              <a href="http://www.newslicensing.co.uk" >Licensing</a>
            </li>
            <li>

              <a href="#" className="optanon-toggle-display">Cookie settings</a>
            </li>
            <li>
              <a href="https://www.thetimes.com/html-sitemap/">Sitemap</a>
            </li>
            <li>
              <a href="https://www.thetimes.com/html-topic-sitemap/">Topics</a>
            </li>
            <li>
              <a href="https://www.thetimes.com/static/commissioning-terms/">Commissioning terms</a>
            </li>
            <li>
              <a href="https://www.thetimes.com/static/terms-and-conditions/">Terms and conditions</a>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default TNLComFooter;
